import { useEffect } from "react";
import useReceipt from "../../../../hooks/useReceipt.jsx";
import Divider from "../../aesthetics/Divider.jsx";
import FormReceiptDateOfArrival from "../../form/FormReceiptDateOfArrival.jsx";
import Modal from "../Modal.jsx";

const ModalUpdateReceiptDateOfArrival = ({ isOpen, onClose, refetchTable, receiptId }) => {
  const { data, loading, error, refetch: refetchReceipt } = useReceipt(receiptId, false);

  useEffect(() => {
    if (isOpen && receiptId) {
      refetchReceipt(receiptId);
    }
  }, [isOpen, receiptId, refetchReceipt]);

  if (!isOpen) return null;
  if (loading) return <div>Cargando documento...</div>;
  if (error) return <div className="text-red-600">Error: {error.response.data.detail}</div>;
  if (!data) return <div>No se han encontrado el documento</div>;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div>
        <h1 className="font-bold">Fecha de la Recepción</h1>
        <span>Introduzca la fecha de la recepción del vuelo {data.local_reference_code}.</span>
      </div>
      <Divider />
      <FormReceiptDateOfArrival onClose={onClose} refetch={refetchTable} receipt={data} />
    </Modal>
  );
};
export default ModalUpdateReceiptDateOfArrival;
